import React from 'react';
import {
    Box,
    Button,
    TextField,
    Typography
} from '@mui/material';
import { Auth } from '@aws-amplify/auth';
import PropTypes from 'prop-types';
import { parseErrorJson } from './helper';
import { loginErrorLink } from 'src/router/routerLink';
import { Navigate } from 'react-router-dom';
import Notification from './Notification';
import { otpSuccess } from './helper';

const EmailLogin = ({
    email,
    setEmail,
    setUser,
    setStep,
    customNoti,
    setCustomNoti,
    handleLogin }) => {
    const initiateAuth = async () => {
        try {
            const cognitoUser = await Auth.signIn(email);
            setUser(cognitoUser);
            setStep(2);
            setCustomNoti({ code: otpSuccess.code, status: otpSuccess.status, title: otpSuccess.title, message: otpSuccess.message })


        } catch (error) {
            const customError = parseErrorJson(error.message);
            if (customError) {
                setCustomNoti({ code: customError.code, status: 'error', title: customError.title, message: customError.message });
            }
            else {
                return <Navigate to={loginErrorLink} replace />;
            }

        }
    };
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column'
            }}
        >

            {customNoti.title && customNoti.message && (
                <Notification noti={customNoti} />
            )}
            <Typography
                sx={{
                    fontSize: '14px',
                    color: 'white',
                    marginTop: '30px',

                }}
            >
                Email*
            </Typography>
            <TextField
                placeholder="Please enter email address"
                variant="outlined"
                size="small"
                required
                onChange={(e) => {
                    setEmail(e.target.value);
                }}
                sx={{
                    marginTop: '5px',
                    width: '300px',
                    fontFamily: 'Lato',
                    fontSize: '12px',
                    lineHeight: '16px',
                    background: '#1E243E',
                    letterSpacing: '0.32px',
                    'input': {
                        '&::placeholder': {
                            fontStyle: 'italic',
                            textAlign: 'left',
                            fontFamily: 'Lato',
                            lineHeight: '16px',
                            fontWeight: 400,
                            color: '#B2B7C2'
                        }
                    },
                    "& .MuiOutlinedInput-root": {
                        "& > fieldset": { borderRadius: 0 },
                    },
                }}
                inputProps={{
                    maxLength: 255,
                }}
            />
            <Button
                sx={{
                    marginTop: '10px',
                    justifyContent: 'center',
                    width: '300px',
                    height: '40px',
                    background: '#6378CA',
                    borderRadius: '2px',
                    '&:hover': {
                        background: '#3D58BD'
                    }
                }}
                onClick={initiateAuth}
                color="primary"
                size="large"
                variant="contained"
            >
                <Typography
                    sx={{
                        whiteSpace: 'nowrap',
                        flexWrap: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        height: '26px',
                        fontWeight: '200',
                        fontSize: '14px',
                        lineHeight: '26px',
                        color: '#FFFFFF'
                    }}
                >
                    Log in
                </Typography>
            </Button>
            <Typography
                onClick={handleLogin}
                sx={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 200,
                    color: 'white',
                    marginTop: '10px',
                    cursor: 'pointer',
                    '&:hover': { color: '#3D58BD', textDecoration: 'underline' },
                    textDecoration: 'underline',
                }}
            >
                Use SSO Credentials to log in
            </Typography>
        </Box>
    )
}
EmailLogin.prototype = {
    email: PropTypes.string,
    setEmail: PropTypes.func,
    setUser: PropTypes.func,
    setStep: PropTypes.func,
    customNoti: PropTypes.object,
    setCustomNoti: PropTypes.func,
    handleLogin: PropTypes.func
}
export default EmailLogin;